import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import {
  BookingItem,
  BookingItemPackage,
  BookingItemRoom,
  Payment,
} from '../../../api/models';
import { BookingService } from '../../../api/services';
import { enumRoomType } from '../../utils/enum-room-type';
import { ConfirmationService, MessageService } from 'primeng/api';
import { enumPaymentMethod } from '../../utils/enum-payment-method';
import { correctDate } from '../../utils/utils';
import { enumPaymentStatus } from '../../utils/enum-payment-status';
import { BookingPaymentByTypePipe } from '../../pipes/booking-payment-by-type.pipe';

@Component({
  selector: 'app-modal-travel-management',
  templateUrl: './modal-travel-management.component.html',
  styleUrl: './modal-travel-management.component.scss',
})
export class ModalTravelManagementComponent {
  activeIndex = 0;
  booking_identifier?: string;
  booking?: BookingItem;
  enumPaymentMethod = enumPaymentMethod;
  enumPaymentStatus = enumPaymentStatus;
  payments: Payment[] = [];

  frmPayment: FormGroup = new FormGroup({
    date: new FormControl(new Date()),
    payment_method: new FormControl(undefined),
  });

  methods = [
    { label: 'Bonifico bancario', id: 1 },
    { label: 'Contanti', id: 2 },
  ];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private bookingService: BookingService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private bookingPaymentByTypePipe: BookingPaymentByTypePipe
  ) {
    if (config.data.idnt) {
      this.booking_identifier = config.data.idnt;
    }
  }

  ngOnInit() {
    this.bookingService
      .bookingControllerGetBooking({
        booking_identifier: this.booking_identifier!,
      })
      .subscribe({
        next: (res) => {
          this.booking = res.data;
        },
      });
  }

  // customer_pays_feesByIndex(index: number): number {
  //   return this.booking?.payments && this.booking.payments[index]
  //     ? this.booking.payments[index].amount * 0.03
  //     : 0;
  // }

  getRoomHeader(room: BookingItemRoom) {
    let room_type;
    let adults = ' ' + room.n_adults + ' adulti ';
    let children;
    switch (room.room_type) {
      case enumRoomType.SGL:
        room_type = 'Camera singola';
        break;
      case enumRoomType.DBL:
        room_type = 'Camera doppia';
        break;
      case enumRoomType.TRP:
        room_type = 'Camera tripla';
        break;
      case enumRoomType.QUD:
        room_type = 'Camera quadrupla';
        break;
    }

    if (room.n_children != 0) {
      children = room.n_children + room.n_infants + ' bambini ';
    } else {
      children = '';
    }
    return `${room_type} (${adults! + children})`;
  }

  getPackageHeader(p: BookingItemPackage) {
    let package_header = '';
    if (p.travel_package.name) {
      package_header = p.travel_package.name;
    } else {
      package_header = 'Nessun pacchetto';
    }
    return package_header;
  }

  registerBankTransfer(identifier: string) {
    this.confirmationService.confirm({
      message: 'Hai ricevuto questo pagamento?',
      header: 'Registrazione pagamento',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sì',
      rejectLabel: 'Annulla',
      acceptButtonStyleClass: 'bg-dialog p-button-sm',
      rejectButtonStyleClass: 'p-button-outlined p-button-sm mr-2',
      accept: () => {
        this.bookingService
          .bookingControllerUpdateBankTransferPayment({
            payment_identifier: identifier,
            body: {
              payed_on: correctDate(
                this.frmPayment.get('date')?.value
              ).toISOString(),
              status_id: this.enumPaymentStatus.PAYED,
            },
          })
          .subscribe({
            next: (res) => {
              this.messageService.add({
                severity: 'success',
                summary: 'Registrazione pagamento',
                detail: 'Pagamento registrato.',
              });
              this.ref.close();
            },
            error: (err) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Registrazione pagamento',
                detail: 'Impossibile registrare il pagamento.',
              });
            },
          });
      },
    });
  }

  close() {
    this.ref.close();
  }

  confirmDelete(id: string) {
    this.confirmationService.confirm({
      message: 'Vuoi eliminare questa prenotazione?',
      header: 'Eliminazione',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sì',
      rejectLabel: 'Annulla',
      acceptButtonStyleClass: 'bg-dialog p-button-sm',
      rejectButtonStyleClass: 'p-button-outlined p-button-sm mr-2',
      accept: () => {
        this.bookingService
          .bookingControllerDeleteBooking({ booking_identifier: id })
          .subscribe({
            next: (res) => {
              this.messageService.add({
                severity: 'success',
                summary: 'Eliminazione',
                detail: 'Prenotazione eliminata con successo.',
              });
              this.ref.close();
            },
            error: (err) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Eliminazione',
                detail: 'Impossibile eliminare la prenotazione.',
              });
            },
          });
      },
    });
  }
}
